import {styled} from '@esgi/ui/theme';

export const StudentManagerLink = styled('a', {
	marginLeft: '5px',
	marginRight: '5px',
	cursor: 'pointer',
});